export const ZINDEX = {
  behind: -1,
  bottom: 0,
  middle: 10,
  top: 20,
  super: 2000,
} as const;

export default ZINDEX;
